export const userConstants = {
  LOGIN_REQUEST: 'USERS_LOGIN_REQUEST',
  LOGIN_SUCCESS: 'USERS_LOGIN_SUCCESS',
  LOGIN_FAILURE: 'USERS_LOGIN_FAILURE',
  LOGIN_REDIRECT_PATH: 'USERS_LOGIN_REDIRECT_PATH',
  LOGOUT: 'USERS_LOGOUT',
};
